module.exports = __webpack_public_path__ + "img/portfolio.49d8135c.svg";